import { useMemo } from "react";
import { Col, Form } from "react-bootstrap";
import { LightRadio } from "components/common";
import { ActuatorCommandMode } from "types/Actuator";

const ModeOptions = ({
    mode,
    modeList,
    isIOController,
    allowLevelOnly = false,
    onChange,
}: {
    mode: string;
    modeList?: string[];
    isIOController: boolean;
    allowLevelOnly?: boolean;
    onChange: (mode: string) => void;
}) => {
    const handleActuatorMode = (item: string) => {
        onChange(item.toUpperCase());
    };

    const finalModeList = useMemo(() => {
        if (modeList) {
            return modeList;
        } else if (!isIOController) {
            return ["Level", "Pulse"];
        }
        return [];
    }, [modeList, isIOController]);

    return (
        <>
            {finalModeList.length > 0 && (
                <>
                    <Form.Label className="mt-2 mb-3">Mode</Form.Label>
                    <Form.Row className="sensor-mode mb-5">
                        {finalModeList.map((item: string) => (
                            <Col md={2} key={item}>
                                <LightRadio
                                    name="modal"
                                    id={item}
                                    checked={mode === item.toUpperCase()}
                                    custom
                                    type="radio"
                                    label={<span className="ml-2">{item}</span>}
                                    onChange={() => {
                                        handleActuatorMode(item);
                                    }}
                                    disabled={
                                        allowLevelOnly &&
                                        item.toUpperCase() !==
                                            ActuatorCommandMode.LEVEL
                                    }
                                />
                            </Col>
                        ))}
                    </Form.Row>
                </>
            )}
        </>
    );
};

export default ModeOptions;
